// removed by extract-text-webpack-plugin
module.exports = {"container":"_1_WQagUGGEZyN8t5EE2K6","inner":"_2MNhLOs33gjbP11kM3Htd5","boa":"_2C52rw8fU0tzEbb0vEvTPk","pan":"_2qP2NMVFn9lG46Dvuk3SjX"};


//////////////////
// WEBPACK FOOTER
// ../components/Wrapper/style.module.less
// module id = 403
// module chunks = 0